import React, { CSSProperties, ReactNode } from "react"
import cn from "classnames"
import Icon, { IconSizes } from "../general/Icon";
import { t } from "../../i18n"

export interface BaseButtonProps {
  children?: ReactNode;
  className?: string;
  danger?: boolean;
  dataTooltip?: null | string;
  hidden?: boolean;
  i18key?: null | string;
  iconSize?: IconSizes;
  iconClass?: string;
  id?: string;
  large?: boolean;
  largeOnMobile?: boolean;
  leftSymbolId?: SvgSymbolId | null;
  light?: boolean;
  maxWidth?: string;
  mobileI18nKey?: string;
  multiline?: boolean;
  noMobileRadius?: boolean;
  inline?: boolean;
  primary?: boolean;
  primaryOnMobile?: boolean;
  rightSymbolId?: SvgSymbolId;
  secondary?: boolean;
  small?: boolean;
  tallOnMobile?: boolean;
  transparent?: boolean;
  wide?: boolean;
}

const renderIcon = (iconSize?: IconSizes, symbolId?: SvgSymbolId, className?: string): JSX.Element | null =>
  symbolId ? <Icon className={cn("Button-icon", className)} size={iconSize} symbolId={symbolId}/> : null;

export function buttonChildren(props: BaseButtonProps): React.ReactNode {
  return (
    <>
      {props.leftSymbolId && renderIcon(props.iconSize, props.leftSymbolId, props.iconClass)}
      {props.i18key && <span className="Button-label">{t(props.i18key)}</span>}
      {props.mobileI18nKey && <span className="Button-mobileLabel">{t(props.mobileI18nKey)}</span>}
      {props.children}
      {renderIcon(props.iconSize, props.rightSymbolId, props.iconClass)}
    </>
  )
}

export function buttonClass(props: BaseButtonProps): string {
  return cn("Button", props.className, {
    "Button--danger": props.danger,
    "Button--large": props.large,
    "Button--largeOnMobile": props.largeOnMobile,
    "Button--light": props.light,
    "Button--inline": props.inline,
    "Button--noMobileRadius": props.noMobileRadius,
    "Button--multiline": props.multiline,
    "Button--primary": props.primary,
    "Button--primaryOnMobile": props.primaryOnMobile,
    "Button--secondary": props.secondary,
    "Button--small": props.small,
    "Button--tallOnMobile": props.tallOnMobile,
    "Button--transparent": props.transparent,
    "Button--wIcon": props.leftSymbolId || props.rightSymbolId,
    "Button--wMobileLabel": props.mobileI18nKey,
    "Button--wide": props.wide,
    "Button-tooltip": props.dataTooltip,
    "hidden": props.hidden,
  })
}

export function buttonStyle(props: BaseButtonProps): CSSProperties {
  const style: CSSProperties = {}
  if (props.maxWidth) style.maxWidth = props.maxWidth
  return style
}
